module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/august/mainvisual-title@2x_4817eb68a70de2554dd01c06ae3a9b0b.png";